import { faClose } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Drawer, Form, Input, message, Select } from "antd";
import Spinner from "@src/components/spinner";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import debounce from 'lodash/debounce';
import { getZonesQuery } from "../../util/query/zone.query";
import { useEffect, useMemo } from "react";
import { CaretDownFilled } from "@ant-design/icons";
import { newKeyGroupMutation, updateKeyGroupMutation } from "../../util/mutation/keyRegister.mutation";
import { getSitesQuery } from "../../util/query/site.query";
import { GetSiteAreasForKeyGroups } from "@src/util/query/siteArea.query";
import { UpsertSiteAreaMutation } from "../../util/mutation/siteArea.mutation";
import Swal from "sweetalert2";


export const NewKeyGroupModal = ({visible, close, groupToBeEdit})=>{

    const [form] = Form.useForm();

    const { data: zoneData, loading: zoneDataLoading } =
    useQuery(getZonesQuery, {
      fetchPolicy: "network-only",
    });



    const [newKeyGroup, {loading: newKeyGroupLoading}] = useMutation(newKeyGroupMutation);

    const [updateKeyGroup, {loading: updateKeyLoading}] = useMutation(updateKeyGroupMutation);

    const handleSave = async ()=>{
        try{

            const values = await form.validateFields();

            // // inHouse custodian: sync key group name with site area
            // if (values.custodianType === 'inHouse') {
            //     if (values.siteAreaId) {
            //         // Site area selected — check if name matches
            //         const area = siteAreas?.find((a) => a._id === values.siteAreaId);
            //         if (area && area.areaname !== values.name) {
            //             const { isConfirmed } = await Swal.fire({
            //                 title: 'Site Area Will Be Renamed',
            //                 html: `The key group name <strong>"${values.name}"</strong> does not match the selected site area <strong>"${area.areaname}"</strong>.<br/><br/>Saving will rename the site area to match the key group name.`,
            //                 icon: 'warning',
            //                 showCancelButton: true,
            //                 confirmButtonText: 'Yes, rename & save',
            //                 cancelButtonText: 'Cancel',
            //                 confirmButtonColor: '#ff7a53',
            //             });
            //             if (!isConfirmed) return;
            //             await upsertSiteArea({
            //                 variables: {
            //                     input: { _id: area._id, siteId: area.siteId, areaname: values.name }
            //                 }
            //             });
            //         }
            //     } else {
            //         // No site area selected — will create a new one
            //         const { isConfirmed } = await Swal.fire({
            //             title: 'New Site Area Will Be Created',
            //             html: `No site area was selected. A new site area named <strong>"${values.name}"</strong> will be created under the selected site.`,
            //             icon: 'info',
            //             showCancelButton: true,
            //             confirmButtonText: 'Yes, create & save',
            //             cancelButtonText: 'Cancel',
            //             confirmButtonColor: '#ff7a53',
            //         });
            //         if (!isConfirmed) return;
            //         // await upsertSiteArea({
            //         //     variables: {
            //         //         input: { siteId: values.siteId, areaname: values.name }
            //         //     }
            //         // });
            //     }
            // }

            if(groupToBeEdit){
                await updateKeyGroup({
                    variables:{
                        input: {_id: groupToBeEdit?._id, ...values}
                    }
                });
                message.success("Key group was updated successfully")
            }else{
                await newKeyGroup({
                    variables:{
                        input: {
                            ...values,
                            
                            
                        }
                    }
                });
                message.success("Key group was added successfully");
            }
            close();

        }catch(err){
            message.error("Please try again")
        }
    };

    
    const [getSites, { data: siteData, loading: siteLoading }] = useLazyQuery(getSitesQuery);
    

    const debouncedGetSites = useMemo(
        () => debounce((searchTerm) => {
            getSites({
                fetchPolicy: "cache-and-network",
                variables: { input: { filters: {
                    advanceFilter:[
                        [{
                            operator: "isInternalSite",
                            condition: "and",
                            filter: "contain_exactly",
                            filterValue: [true]
                        }]
                    ]
                }, search: searchTerm, page: 1, pageSize: 5 } },
            });
        }, 300),
        []
    );


    
    const [upsertSiteArea] = useMutation(UpsertSiteAreaMutation);

    const custodianType = Form.useWatch('custodianType', form);
    const selectedSite = Form.useWatch('siteId', form);

    const {data} = useQuery(GetSiteAreasForKeyGroups,{
        fetchPolicy: 'cache-and-network',

        variables:{
            siteId: selectedSite ?? selectedSite
        },
        skip: !selectedSite

    });

    const siteAreas = data?.getSiteAreasForKeyGroups?.map((area)=>({...area, key: area?._id}));

    const handleSiteAreaChange = async (areaId) => {
        const area = siteAreas?.find((a) => a._id === areaId);
        if (!area) return;

        const { isConfirmed, isDenied } = await Swal.fire({
            title: 'Key Group Name',
            html: `Do you want to name the key group <strong>"${area.areaname}"</strong> (same as the site area)?`,
            icon: 'question',
            showConfirmButton: true,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes, use site area name',
            denyButtonText: 'No, I\'ll set my own name',
            confirmButtonColor: '#ff7a53',
            denyButtonColor: '#6c757d',
        });

        if (isConfirmed) {
            form.setFieldValue('name', area.areaname);
        } else if (isDenied) {
            await Swal.fire({
                title: 'Heads up!',
                html: `Whatever name you enter will also <strong>rename the site area "${area.areaname}"</strong> to match it.`,
                icon: 'warning',
                confirmButtonText: 'Got it, continue',
                confirmButtonColor: '#ff7a53',
            });

            const { value: keyGroupName, isConfirmed: nameConfirmed } = await Swal.fire({
                title: 'Enter Key Group Name',
                input: 'text',
                inputPlaceholder: 'Enter key group name...',
                inputValue: form.getFieldValue('name') || '',
                showCancelButton: true,
                confirmButtonText: 'Save',
                confirmButtonColor: '#ff7a53',
                inputValidator: (val) => !val?.trim() ? 'Please enter a key group name' : null,
            });

            if (nameConfirmed && keyGroupName?.trim()) {
                form.setFieldValue('name', keyGroupName.trim());
                try {
                    await upsertSiteArea({
                        variables: {
                            input: { id: area._id, siteId: area.siteId, areaname: keyGroupName.trim() }
                        }
                    });
                    message.success(`Site area renamed to "${keyGroupName.trim()}"`);
                } catch {
                    message.error('Failed to rename site area');
                }
            }
        }
    };

    return(
        <Drawer
            title={`${groupToBeEdit? "Update": "New"} Key Group`}
            placement="right"
            closable={true}
            onClose={close}
            closeIcon={<FontAwesomeIcon icon={faClose} className='close-icon'/>}
            visible={visible}
            width={600}

            maskClosable={false}
            mask={true}
            footer={
            <div className='drawer-footer'>
                <button disabled={newKeyGroupLoading || updateKeyLoading} className={updateKeyLoading || newKeyGroupLoading? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} onClick={handleSave}>
                {updateKeyLoading || newKeyGroupLoading? <Spinner color={"#ff7a53"}/> : 'Save'}
                </button>
                <button disabled={updateKeyLoading||newKeyGroupLoading} className='drawer-outlined-btn' onClick={close}>Cancel</button>
            </div>
            }
        >
            <Form
                layout="vertical"
                disabled={updateKeyLoading || newKeyGroupLoading}
                loading={updateKeyLoading || newKeyGroupLoading}
                form={form}
                requiredMark={false}
                initialValues={{
                    name: groupToBeEdit?.record?.name || "",
                    zoneId: groupToBeEdit?.record?.zoneId || null ,
                    description: groupToBeEdit?.record?.description || ""
                }}
            >
                {/* <Form.Item
                    label={"Custodian Type"}
                    rules={[{required: true, message: "Please select custodian type "}]}
                    name="custodianType"
                >
                    <Select 
                        placeholder="Please select custodian type"
                        className="custom-select"
                        suffixIcon={<CaretDownFilled/>}
                    >
                        <Option value="supplier">Supplier</Option>
                        <Option value="inHouse">In House</Option>
                    </Select>
                </Form.Item> */}


                {/* Site */}
                {/* {custodianType === 'inHouse' && <Form.Item
                    label={"Site"}
                    name="siteId"
                    rules={[{ required: true, message: "Please select a site" }]}
                    style={{marginTop:'16px'}}

                >
                    <Select
                        showSearch
                        className="custom-select"
                        onSearch={debouncedGetSites}
                        // onDropdownVisibleChange={(open) => {
                        //     if (open) {
                        //         getSites({
                        //             fetchPolicy: "cache-and-network",
                        //             variables: { input: { filters: null, search: "", page: 1, pageSize: 5 } },
                        //         });
                        //     }
                        // }}
                        placeholder="Select site (Internal Site ONLY)"
                        loading={siteLoading}
                        filterOption={false}
                        suffixIcon={!siteLoading ? <CaretDownFilled /> : <Spinner />}
                        onChange={() => form.setFieldValue('siteAreaId', null)}
                    >
                        {siteLoading
                            ? <Select.Option hidden disabled>Loading ...</Select.Option>
                            : siteData?.sites?.sites?.map((site) => (
                                <Select.Option key={site?._id} value={site?._id}>
                                    {site?.sitename} - Internal Site
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>} */}


                {/* Site Area */}
                {/* {custodianType === 'inHouse' && <Form.Item
                    label={"Site Area"}
                    name="siteAreaId"
                    rules={[{ required: false, message: "Please select a site area" }]}
                    style={{marginTop:'16px'}}

                >
                    <Select
                        showSearch
                        className="custom-select"
                        placeholder="Select site area"
                        filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                        suffixIcon={<CaretDownFilled />}
                        onChange={handleSiteAreaChange}
                    >
                        {siteAreas?.map((area) => (
                            <Select.Option key={area?._id} value={area?._id}>
                                {area?.areaname}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>} */}




                <Form.Item
                    label={"Key group name"}
                    style={{marginTop:'16px'}}
                    rules={[{required: true, message: "Please enter name "}]}
                    name="name"
                >
                    <Input 
                        placeholder="Key group name"
                        className="generic-input-control"
                    />
                </Form.Item>

                {/* <Form.Item
                    label={"Zone"}
                    rules={[{required: true, message: "Please select a zone"}]}
                    name={"zoneId"}
                > */}
                    {/* <Select
                        // showSearch
                        // filterOption={false}
                        className="custom-select"
                        // onSearch={debouncedGetZones}
                        placeholder="Select zone"
                        loading={zoneDataLoading}
                        suffixIcon={!zoneDataLoading ? <CaretDownFilled /> : <Spinner />}
                        
                    > */}
                        {/* Show the current zone as an option when editing */}
                       

                        {/* Always show the current zone when editing */}
                        {/* {groupToBeEdit?.record?.zone && 
                            // !zoneData?.getZones?.response?.find(z => z._id === groupToBeEdit.record.zone._id) && (
                            <Select.Option key={ groupToBeEdit?.record?.zoneId } value={ groupToBeEdit?.record?.zoneId }>
                                {groupToBeEdit.record.zone.name}
                            </Select.Option>
                        // )
                        }

                        {
                             zoneData?.getZones?.response?.map((zone) => (
                                <Select.Option key={zone?._id} value={zone?._id}>
                                    {zone?.name}
                                </Select.Option>
                            ))
                        }
 */}

                    {/* </Select> */}

                {/* </Form.Item> */}

                <Form.Item
                    label={"Description"}
                    style={{marginTop:'16px'}}
                    name={"description"}
                >
                    <Input 
                        placeholder="Any description"
                        className="generic-input-control"
                    />
                </Form.Item>


            </Form>

        </Drawer>
    )
}